export const API_CONSTANTS = {
  SCREEN_REFRESH: '/screenRefresh', // TODO
  API_GATEWAY: {
    SERVICE: '/apiGatewayService/execute',
  },
  ACTION_HANDLER: {
    ENDPOINT: {
      SEND_RTJ_DATA_BLOCK: '/sendRTJDataBlock',
      UNLINK_MULTIPLE_CASES: '/unlinkMultipleCases',
    },
  },
  AUDIT_DATA: {
    ENDPOINT: {
      GET_FILTERED_AUDITS: '/getFilteredAudits',
    },
  },
  AUTHENTICATION: {
    SERVICE: '/authenticationService',
    ENDPOINT: {
      AUTHENTICATE_USER: '/token/authenticate',
      REVALIDATE_USER_ROLE: '/revalidateUserRole',
      TOKEN_RENEW: '/token/renew',
      TOKEN_STATUS: '/token/status',
    },
  },
  CASE_MANAGER: {
    SERVICE: '/caseManagerService',
    ENDPOINT: {
      GET_CASE: '/getCase',
      GET_SEARCH_RELATED_CASE_FILES: '/getSearchRelatedCaseFiles',
      GET_LINKED_CASES_LIST: '/getLinkedCasesList',
      DELETE_CASE_LINK: '/deleteCaseLink',
      EXPORT_CASE_DETAILS: '/exportCaseDetails',
      CREATE_CASE: '/createCase',
      GET_DATA_PARTICLES_LIST: '/getDataParticlesList',
      CREATE_REQUEST_TO_JOIN: '/createRequestToJoin',
      GET_REQUESTS_TO_JOIN_BY_CASE_ID: '/getRequestsToJoinByCaseId',
      CREATE_MULTIPLE_LINK_CASE: '/linkMultipleCases',
      GET_BUSINESS_KEYS_AND_LABELS_BY_DOCUMENT_GROUP: '/getBusinessKeysAndLabelsByDocumentGroup',
    },
  },
  CONFIG_MANAGER: {
    ENDPOINT: {
      GET_ITEMS_FROM_DATA_MODEL_CODE_BY_WORKFLOW: '/getItemsFromDataModelCodeByWorkflow',
      GET_PROJECT_SETTINGS_BY_PROJECT_NAME: '/getProjectSettingsbyProjectName',
      GET_PROJECT_SETTINGS_BY_WORKFLOW: '/getProjectSettingsbyWorkflow',
      GET_DATA_BLOCK_MODEL_BY_WORKFLOW: '/getDataBlockModelByWorkflow',
      GET_COLUMN_CONFIG_BY_WORKFLOW_AND_TYPE: '/getColumnConfigByWorkflowAndType',
      GET_SORTED_TASK_WORKFLOWS: '/getSortedTaskWorkflows',
      GET_CASE_TAGS: '/getCaseTags',
      GET_CASE_LINK_OPTIONS_BY_WORKFLOW: '/getCaseLinkOptionsByWorkflow',
      GET_DUE_DILIGENCE_FILTER_BY_WORKFLOW: '/getDueDiligenceFilterByWorkflowAndLanguage',
      GET_DATA_MODEL_BY_WORKFLOW: '/getDataModelByWorkflow',
      GET_DATA_MODEL_ITEMS_BY_WORKFLOW: '/getDataModelItemsByWorkflow',
      GET_DATA_MODEL_ITEM_BY_ID: '/getDataModelItemById',
      GET_DOCUMENT_CENTER_CONFIG: '/getDocumentCenterConfig',
      GET_ABOUT_PAGE: '/getAboutPage',
      CREATE_ABOUT_PAGE: '/createAboutPage',
      GET_ABOUT_PAGE_BY_ID: '/getAboutPageById',
      UPDATE_ABOUT_PAGE_BY_ID: '/updateAboutPageById',
      DELETE_ABOUT_PAGE: '/deleteAboutPage',
      DELETE_ABOUT_PAGE_BY_ID: '/deleteAboutPageById',
      GET_PROJECT_SECURITY_ATTRIBUTES: '/getProjectSecurityAttributes',
      GET_CASE_DATA_ATTRIBUTES: '/getCaseDataAttributes',
      GLOBAL_SEARCH_MAPPING: '/globalSearchMapping',
      PDF_INFO: '/pdfInfo',
      GET_WORKFLOW_LIST: '/getWorkflowList',
      GET_POLICY_BY_ID: '/getPolicyById',
    },
  },
  CONTENT_GENERATOR: {
    ENDPOINT: {
      GET_MESSAGE_TEMPLATES: '/getMessageTemplates',
      POPULATE_MESSAGE_TEMPLATES: '/populateMessageTemplates',
      GET_DRAFTS_NAMES_LIST: '/getDraftsNamesList',
      GET_DRAFT_BY_CASE_ID_AND_NAME: '/getDraftByCaseIdAndName',
      COPY_DRAFT_BY_CASE_ID_AND_NAME: '/copyDraftByCaseIdAndName',
      UPDATE_DRAFT_BY_ID: '/updateDraftById',
      DELETE_DRAFT_BY_ID: '/deleteDraftById',
    },
  },
  CONTENT_MANAGER: {
    ENDPOINT: {
      GET_DOCUMENT_BY_ID: '/getDocumentById',
      DELETE_DOCUMENT: '/deleteDocument',
    },
  },
  DATA_BLOCK_BUILDER: {
    ENDPOINT: {
      UPLOAD_DOCUMENT: '/uploadDocument',
      SEND_DATA_BLOCK: '/sendDataBlock',
      UPDATE_DOCUMENT: '/updateDocument',
    },
  },
  DATA_GATEWAY: {
    SERVICE: '/dataGatewayService',
    ENDPOINT: {
      GRAPHQL: '/dataGatewayService/graphql',
    },
  },
  DOCUMENT_MANAGER_SERVICE: {
    ENDPOINT: {
      GET_DOCUMENT_METADATA_LIST: '/getDocumentMetadataList',
      UPLOAD_CONTENT_DOCUMENT: '/uploadContentDocument',
    },
  },
  DD: {
    ENDPOINT: {
      GET_ALL_DUE_DILIGENCE_REQUESTS: '/getAllDueDiligenceRequests',
      GET_DUE_DILIGENCE_REQUEST_BY_ID: '/getDueDiligenceRequestById',

      GET_DUE_DILIGENCE_REQUESTS_BY_CASE_ID_AND_API_NAME:
        '/getDueDiligenceRequestsByCaseIdAndApiName',
      CREATE_DUE_DILIGENCE_REQUEST: '/createDueDiligenceRequest',
      UPDATE_DUE_DILIGENCE_REQUEST: '/updateDueDiligenceRequest',
      GET_DUE_DILIGENCE_COMMENTS: '/getDueDiligenceComments',
      CREATE_DUE_DILIGENCE_COMMENT: '/createDueDiligenceComment',
      UPDATE_DUE_DILIGENCE_COMMENT: '/updateDueDiligenceComment',
      ADD_DUE_DILIGENCE_PARTY: '/addDueDiligenceParty',
      REMOVE_DUE_DILIGENCE_PARTY: '/removeDueDiligenceParty',
      GET_DUE_DILIGENCE_PARTIES_BY_CASE_ID: '/getDueDiligencePartiesByCaseId',
      GET_DUE_DILIGENCE_PDF_BY_ID: '/getDueDiligencePdfById',
      DUE_DILIGENCE_BUSINESS_ANALYSIS_REQUEST: '/duediligenceBusinessAnalysisRequest',
      DUE_DILIGENCE_PERSON_ANALYSIS_REQUEST: '/duediligencePersonAnalysisRequest',
      GET_DUE_DILIGENCE_RESPONSE_BY_CASE_ID_AND_API_NAME_AND_SEARCH_TYPE_AND_GROUP_ID_AND_ENTITY_ID:
        '/getDueDiligenceResponseByCaseIdAndAPINameAndSearchTypeAndGroupIdAndEntityId',
      GET_DUE_DILIGENCE_RESPONSE_BY_CASE_ID_AND_API_NAME_AND_SEARCH_TYPE_AND_GROUP_ID_AND_COMPANY_ENTITY_ID:
        '/getDueDiligenceResponseByCaseIdAndAPINameAndSearchTypeAndGroupIdAndCompanyEntityId',
      CREATE_DUE_DILIGENCE_REPORT_REQUEST: '/createDueDiligenceReportRequest',
      SEND_REQUEST_TO_DELETE_IMAGE: '/sendRequestToDeleteImage',
    },
  },
  EMAIL: {
    ENDPOINT: {
      SEND_MAIL: '/sendMail',
      GET_MAILS_BY_CASE_ID: '/getMailsByCaseId',
    },
  },
  GLOBAL_QUERY: {
    ENDPOINT: {
      GET_PAGE_LIST: '/getPageList',
      GET_FILTERED_TASKS: '/getFilteredTasks',
      GET_FILTERED_CASES: '/getFilteredCases',
      GET_FILTERED_COUNT: '/getFilteredCount',
      EXPORT_LIST_CONTENT: '/exportListContent',
      GET_TASKS_BY_CASE_ID: '/getTasksByCaseId',
    },
  },
  NARRATIVE_GENERATION: {
    SERVICE: '/narrativeGenerationService',
    ENDPOINT: {
      GET_NARRATIVE_TEMPLATES_DROPDOWN_BY_WORKFLOW: '/getNarrativeTemplatesDropdownByWorkflow',
      GET_NARRATIVE_VERSIONS_DROPDOWN: '/getNarrativeVersionsDropdown',
      GET_NARRATIVE_TEMPLATE_BY_ID: '/getNarrativeTemplateById',
      UPDATE_NARRATIVE_TEMPLATE_BY_ID: '/updateNarrativeTemplateById',
      DELETE_NARRATIVE_TEMPLATE_BY_ID: '/deleteNarrativeTemplateById',
      RESTORE_NARRATIVE_TEMPLATE_BY_ID: '/restoreNarrativeTemplateById',
      RESET_NARRATIVE_TEMPLATE_BY_ID: '/resetNarrativeTemplateById',
      GENERATE_NARRATIVE_TEMPLATE_BY_ID: '/generateNarrativeTemplateById',
      NARRATIVE_PDF_UPLOAD: '/narrativePdfUpload',
    },
  },
  NOTIFICATION_MANAGER: {
    ENDPOINT: {
      GET_PAGINATED_NOTIFICATIONS: '/getPaginatedNotifications',
      DISMISS_NOTIFICATION_BY_ID: '/dismissNotificationById',
      DISMISS_ALL_NOTIFICATIONS_BY_USER: '/dismissAllNotificationsByUser',
    },
  },
  ROLES_MANAGER: {
    ENDPOINT: {
      GET_ALL_USERS_BY_PROJECT: '/getAllUsersByProject',
      GET_USER: '/getUser',
      GET_USER_SETTINGS: '/getUserSettings',
      GET_ROLE_BY_NAME: '/getRoleByName',
      CREATE_USER_CUSTOM_VIEWS_BY_LABEL: '/createUserCustomViewsByLabel',
      DELETE_USER_CUSTOM_VIEWS_BY_ID: '/deleteUserCustomViewsById',
      GET_USER_CUSTOM_VIEWS_BY_USER_AND_TYPE: '/getUserCustomViewsByUserAndType',
      GET_PROJECT_SECURITY_ASSETS: '/getProjectSecurityAssets',
      GET_CASE_ROLES_BY_PROJECT: '/getCaseRolesByProject',
      GET_PERMISSIONS_BY_ROLE: '/permissions',
    },
  },
  SCREEN_GENERATOR: {
    ENDPOINT: {
      CREATE_CASE_360_DATA_TEMPLATE: '/createCase360DataTemplate',
      GET_CASE_360_HEADER_BY_WORKFLOW: '/getCase360HeaderByWorkflow',
    },
  },
  TASK_MANAGER: {
    SERVICE: '/taskManagerService',
    ENDPOINT: {
      TASK: '/task',
      GET_SCREEN_FILE: '/getScreenFile',
      GET_COMPLETED_TASK: '/getCompletedTask',
      SEND_DRAFT: '/sendDraft',
      SUBMIT_TASK: '/submitTask',
      GET_SPECIFIC_TAB: '/getSpecificTab',
      GET_UNASSIGNED_TASKS: '/getUnassignedTasks',
      PATCH_TASK: '/patchTask',
      TASK_MANAGER_SERVICE: '/taskManagerService',
    },
  },
  SSE_MANAGER: {
    ENDPOINT: '/sse/stream/',
    CHANNELS: {
      SCREEN_REFRESH: 'screen_refresh',
      TASK_REASSIGNMENT: 'taskReassignmentTask',
      TASK_REASSIGNMENT_TASKLIST: 'task_reassignment_tasklist',
      CANCELLED_TASKS: 'cancelled_tasks',
    },
  },
} as const;
